export const SG7_LEAGUES = [
  { id: "world-cup", name: "FIFA World Cup", apiId: 1, short: "World Cup" },
  { id: "brasileirao", name: "Brasil (Série A)", apiId: 71, short: "Brasileirão" },
  { id: "premier-league", name: "Inglaterra (Premier League)", apiId: 39, short: "Premier League" },
  { id: "ligue-1", name: "França (Ligue 1)", apiId: 61, short: "Ligue 1" },
  { id: "bundesliga", name: "Alemanha (Bundesliga)", apiId: 78, short: "Bundesliga" },
  { id: "serie-a", name: "Itália (Serie A)", apiId: 135, short: "Serie A" },
  { id: "eredivisie", name: "Holanda (Eredivisie)", apiId: 88, short: "Eredivisie" },
  { id: "liga-portugal", name: "Portugal (Liga)", apiId: 94, short: "Liga Portugal" },
  { id: "la-liga", name: "Espanha (La Liga)", apiId: 140, short: "La Liga" },
  { id: "wc-qualification-europe", name: "World Cup Qualification (Europe)", apiId: 32, short: "WC Qual." },
  { id: "champions-league", name: "UEFA Champions League", apiId: 2, short: "UCL" },
  { id: "europa-league", name: "UEFA Europa League", apiId: 3, short: "UEL" },
  { id: "conference-league", name: "UEFA Conference League", apiId: 848, short: "UECL" },
  { id: "saudi-pro-league", name: "Arábia Saudita (Pro League)", apiId: 307, short: "Saudi Pro" },
  { id: "segunda-liga", name: "Portugal (Segunda Liga)", apiId: 95, short: "Segunda Liga" },
  { id: "superliga-dk", name: "Dinamarca (Superliga)", apiId: 119, short: "Superliga DK" },
  { id: "premiership-sc", name: "Escócia (Premiership)", apiId: 179, short: "Premiership SC" },
  { id: "super-lig", name: "Turquia (Super Lig)", apiId: 203, short: "Super Lig" },
  { id: "championship", name: "Inglaterra (Championship)", apiId: 40, short: "Championship" },
  { id: "bundesliga-2", name: "Alemanha (Bundesliga 2)", apiId: 79, short: "Bundesliga 2" },
];

export const LEAGUE_MAPPING = SG7_LEAGUES.reduce((acc, league) => {
  acc[league.id] = league;
  return acc;
}, {} as Record<string, typeof SG7_LEAGUES[0]>);

export const API_FOOTBALL_BASE_URL = "https://v3.football.api-sports.io";

// Ligas de seleções nacionais (mostrar clube em vez de nacionalidade nos lineups)
export const NATIONAL_TEAM_LEAGUES = [
  1,    // FIFA World Cup
  32,   // World Cup Qualification (Europe)
  5,    // UEFA Nations League
  960,  // UEFA Euro Qualification
  4,    // UEFA Euro
  9,    // Copa America
  10,   // African Cup of Nations
  33,   // World Cup Qualification (South America)
] as const;

// Helper function para verificar se é liga de seleções
export const isNationalTeamLeague = (leagueApiId: number | undefined): boolean => {
  return leagueApiId ? NATIONAL_TEAM_LEAGUES.includes(leagueApiId as any) : false;
};

// Configuração de zonas de qualificação específicas por liga (temporada 2024/2025)
export const LEAGUE_QUALIFICATION_ZONES: Record<number, {
  zones: Array<{
    positions: number[];
    label: string;
    color: string;
  }>;
} | null> = {
  // ========== COMPETIÇÕES FIFA ==========
  1: { // FIFA World Cup (12 grupos de 4)
    zones: [
      { positions: [1, 2], label: 'Apuramento Direto', color: 'green' },
      { positions: [3], label: 'Repescagem (8 melhores 3ºs)', color: 'blue' }
    ]
  },

  // ========== LIGA SUL-AMERICANA ==========
  71: { // Brasileirão Série A
    zones: [
      { positions: [1, 2, 3, 4, 5, 6], label: 'Copa Libertadores', color: 'green' },
      { positions: [7, 8, 9, 10, 11, 12], label: 'Copa Sul-Americana', color: 'blue' },
      { positions: [-4, -3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  // ========== TOP 5 LIGAS EUROPEIAS ==========
  39: { // Premier League (Inglaterra)
    zones: [
      { positions: [1, 2, 3, 4], label: 'Champions League', color: 'green' },
      { positions: [5], label: 'Europa League', color: 'blue' },
      { positions: [6], label: 'Conference League', color: 'cyan' },
      { positions: [-3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  140: { // La Liga (Espanha)
    zones: [
      { positions: [1, 2, 3, 4], label: 'Champions League', color: 'green' },
      { positions: [5], label: 'Europa League', color: 'blue' },
      { positions: [6], label: 'Conference League', color: 'cyan' },
      { positions: [-3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  135: { // Serie A (Itália)
    zones: [
      { positions: [1, 2, 3, 4], label: 'Champions League', color: 'green' },
      { positions: [5], label: 'Europa League', color: 'blue' },
      { positions: [6], label: 'Conference League', color: 'cyan' },
      { positions: [-3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  78: { // Bundesliga (Alemanha)
    zones: [
      { positions: [1, 2, 3, 4], label: 'Champions League', color: 'green' },
      { positions: [5], label: 'Europa League', color: 'blue' },
      { positions: [6], label: 'Conference League', color: 'cyan' },
      { positions: [-2, -1], label: 'Despromoção', color: 'red' },
      { positions: [-3], label: 'Playoff Despromoção', color: 'orange' }
    ]
  },

  61: { // Ligue 1 (França)
    zones: [
      { positions: [1, 2, 3], label: 'Champions League', color: 'green' },
      { positions: [4], label: 'Champions Qualificação', color: 'emerald' },
      { positions: [5], label: 'Europa League', color: 'blue' },
      { positions: [6], label: 'Conference League', color: 'cyan' },
      { positions: [-2, -1], label: 'Despromoção', color: 'red' },
      { positions: [-3], label: 'Playoff Despromoção', color: 'orange' }
    ]
  },

  // ========== OUTRAS LIGAS EUROPEIAS ==========
  88: { // Eredivisie (Holanda)
    zones: [
      { positions: [1], label: 'Champions League', color: 'green' },
      { positions: [2], label: 'Champions Qualificação', color: 'emerald' },
      { positions: [3], label: 'Europa League', color: 'blue' },
      { positions: [4], label: 'Conference League', color: 'cyan' },
      { positions: [-1], label: 'Despromoção', color: 'red' },
      { positions: [-2], label: 'Playoff Despromoção', color: 'orange' }
    ]
  },

  94: { // Liga Portugal
    zones: [
      { positions: [1], label: 'Champions League', color: 'green' },
      { positions: [2], label: 'Champions Qualificação', color: 'emerald' },
      { positions: [3], label: 'Europa League', color: 'blue' },
      { positions: [4], label: 'Conference League', color: 'cyan' },
      { positions: [-2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  // ========== QUALIFICAÇÕES INTERNACIONAIS ==========
  32: { // World Cup Qualification (Europe)
    zones: [
      { positions: [1], label: 'Direct Qualification', color: 'green' },
      { positions: [2], label: 'Playoff', color: 'blue' }
    ]
  },

  // ========== COMPETIÇÕES UEFA (sem zonas) ==========
  2: null,   // Champions League
  3: null,   // Europa League
  848: null, // Conference League

  // ========== OUTRAS LIGAS ==========
  307: { // Saudi Pro League
    zones: [
      { positions: [1, 2], label: 'AFC Champions League', color: 'green' },
      { positions: [3], label: 'AFC Champions League Qual.', color: 'emerald' },
      { positions: [-3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  95: { // Portugal Segunda Liga
    zones: [
      { positions: [1, 2], label: 'Promoção Directa', color: 'green' },
      { positions: [3, 4], label: 'Playoff Promoção', color: 'blue' },
      { positions: [-2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  // ========== LIGAS EXPANDIDAS ==========
  119: { // Superliga (Dinamarca)
    zones: [
      { positions: [1], label: 'Champions League Qual.', color: 'green' },
      { positions: [2, 3], label: 'Conference League Qual.', color: 'cyan' },
      { positions: [-1], label: 'Despromoção', color: 'red' },
      { positions: [-2], label: 'Playoff Despromoção', color: 'orange' }
    ]
  },

  179: { // Premiership (Escócia)
    zones: [
      { positions: [1], label: 'Champions League Qual.', color: 'green' },
      { positions: [2, 3], label: 'Europa League Qual.', color: 'blue' },
      { positions: [-1], label: 'Despromoção', color: 'red' }
    ]
  },

  203: { // Super Lig (Turquia)
    zones: [
      { positions: [1, 2, 3], label: 'Champions League', color: 'green' },
      { positions: [4], label: 'Europa League', color: 'blue' },
      { positions: [5], label: 'Conference League', color: 'cyan' },
      { positions: [-4, -3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  40: { // Championship (Inglaterra)
    zones: [
      { positions: [1, 2], label: 'Promoção Directa', color: 'green' },
      { positions: [3, 4, 5, 6], label: 'Playoff Promoção', color: 'blue' },
      { positions: [-3, -2, -1], label: 'Despromoção', color: 'red' }
    ]
  },

  79: { // Bundesliga 2 (Alemanha)
    zones: [
      { positions: [1, 2], label: 'Promoção Directa', color: 'green' },
      { positions: [3], label: 'Playoff Promoção', color: 'blue' },
      { positions: [-2, -1], label: 'Despromoção', color: 'red' }
    ]
  }
};